import React, { useState } from "react";
import { ButtonData, Node } from "./canvas-utils";
import { ActiveTarget } from "./AutomationConstructor";
import { Button, Input, TextField } from "@mui/material";

interface ButtonEditFormProps {
  target: ActiveTarget | null;
  onSave: (button: ButtonData) => void;
}

const ButtonEditForm = ({ target, onSave }: ButtonEditFormProps) => {
  const [text, setText] = useState(target?.payload?.button?.text || "");
  const [url, setUrl] = useState(target?.payload?.button?.url || "");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!target) return;
    onSave({
      ...(target.payload?.button as ButtonData),
      text,
      url,
    });
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <TextField
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          fullWidth
          placeholder="Введите название"          
          label="Название кнопки"
        />

        <TextField
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          fullWidth
          placeholder="Введите URL"
          label="URL кнопки"
        />

        <div className="mt-8">
          <Button variant="contained" type="submit" fullWidth disabled={!text}>
            Сохранить
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ButtonEditForm;
